export const Endpoint = "tasks/patch-task-item";
export const Method = "POST";
export const RateLimitingConfig = {
    calls: 1,
    per: 750,
};
